export enum SortingOption {
    CreatedOnAsc = "CreatedOnAsc",
    CreatedOnDesc = "CreatedOnDesc",
    DirNameAToZ = "DirNameAToZ",
    DirNameZToA = "DirNameZToA"
}

export enum FileType {
    Pdf = "Pdf", 
    Pptx = "Pptx", 
    Xls = "Xls", 
    Xlsx = "Xlsx", 
    Docx = "Docx", 
    Doc = "Doc", 
    Csv = "Csv", 
    Txt = "Txt", 
    Md = "Md", 
    Directory = "Directory"
}

export enum InsightQubeStatus {
    Created="Created",  
    EmbeddingQueued="EmbeddingQueued",  
    Processing="Processing",
    Completed="Completed",
    Failed="Failed"
}